export default{
  showpath:'',
  userInfo:{},
  dutyList:[],//责任方式
  awardList:[],//奖项方式
  levelList:[],//级别
  jmkcate:[],   // 节目库分类
  exhibitCate:[], // 展品库分类
  literatureCate: [], // 文学库分类
  aboutContent:'',
  loginTimes:0,
  loginDisTime:'',
  lockCount: '',
  activityCate:[],//活动分类,
  posterCate:[],//海报分类,
  totalFilter: [],
  awardCate:[{ id:3, name: "节目" }, { id:7, name: "展品" }, { id:6, name: "文学" }],
  UserRightMenu: [
    { id:1, name: "授权资源",icon:'iconfont2 icon2-verified-badge-line', count: 0 },
    { id:3, name: "我的点赞",icon:'iconfont2 icon2-thumb-up-line', count: 0 },
    { id:4, name: "我的收藏",icon:'iconfont  icon-star-line', count: 0 },
    { id:2, name: "下载记录",icon:'iconfont icon-download-2-line', count: 0 }
  ]
}